<script setup lang="ts">
import { TransitionPresets } from '@vueuse/core'

const notProd = import.meta.env.MODE !== 'production'

const source = ref(0)

const isPaidUser = ref(true)
const router = useRouter()
const route = useRoute()

const show = ref(false)

onMounted(() => {
  isPaidUser.value = getSessionEnhanced().isPaidUser

  if (brand.id === 'sd') {
    const afid = getSessionEnhanced().query.afid

    const allowedAfids = [
      '811171',
      '811314',
      '811316',
      '811362',
      '811376',
      '811069',
      '811071',
      '811117',
      '811085',
      '811283',
      '811299',
      '811296',
    ]

    if (!afid || !allowedAfids.includes(afid)) {
      router.replace({
        path: '/',
        query: route.query,
      })
      return
    }
  }

  // if (!isPaidUser.value && import.meta.env.MODE === 'production') {
  //   router.push('/go-4-benefits')
  //   return
  // }

  if (brand.id === 'bridge') {
    router.replace({
      path: '/my-otc-benefits-g3r',
      query: route.query,
    })
    return
  }

  show.value = true
})

const isMobile = useIsMobile()

const destination = computed(() => {
  if (
    import.meta.env.MODE === 'production' &&
    (!isMobile.value || !isWorkingHours.value)
  ) {
    return '/ads'
  }

  let value =
    import.meta.env.MODE === 'production'
      ? '/additional-benefits-otc/call'
      : '/additional-benefits-grocery/call-now'

  if (brand.id === 'bridge' && !import.meta.env.SSR) {
    const domain = 'https://benefit-helpline.com'
    const params = new URLSearchParams()

    Object.entries(getSessionEnhanced().query).forEach(([key, value]) => {
      if (value) {
        params.set(key, value)
      }
    })

    params.set('session_id', getSession().id)

    if (exp.value?.otcAdDestination) {
      const variant = exp.value.otcAdDestination.toBenefits
        ? 'toBenefits'
        : 'original'

      params.set('exp', `otc-ad-destination-2023-10-20@${variant}`)
    }

    const qs = params.toString() && `?${params.toString()}`

    value = domain + value + qs
  }

  return value
})

onMounted(async () => {
  await until(() => ip.lookup).toBeTruthy({ timeout: 2000 })

  const state = states.find((state) => state.code === ip.lookup?.stateCode)

  const minOtc = state?.minOtc ?? 0
  const minOtcLtd = state?.minOtcLtd ?? 500

  source.value = notProd
    ? minOtc
    : isPaidUser.value
    ? minOtcLtd
    : Math.min(minOtcLtd, 500)
})

const output = useTransition(source, {
  duration: 2500,
  transition: TransitionPresets.easeInOutQuart,
})

const card = ref(null)

const { height } = useElementSize(card)

const name = computed(() => {
  const firstname = query.firstname?.trim() || ''
  const lastname = query.lastname?.trim() || ''
  const fullName = `${firstname} ${lastname}`.trim()
  return fullName.length > 15 && firstname && lastname
    ? `${firstname.charAt(0)} ${lastname}`
    : fullName
})

const showBackButtonModal = ref(false)

onMounted(() => {
  const forward = router.options.history.state.forward
  if (typeof forward === 'string' && forward.includes('grocery')) {
    showBackButtonModal.value = true
  }
})
</script>

<template>
  <Layout
    v-if="show"
    hide-header
    footer="2025"
    class="bg-[#f7f7f7] min-h-screen p-6 relative"
  >
    <template #banner v-if="!isMobile">
      <Banner> New to Medicare? Turning 65? </Banner>
    </template>
    <span
      class="absolute text-xs top-2 right-2 border border-black p-1 rounded"
    >
      Ad
    </span>
    <div class="container !max-w-screen-sm py-6 space-y-6">
      <div class="text-4xl font-bold font-dm" v-if="isMobile">
        <div>You may get</div>
        <span class="text-red text-5xl">${{ output.toFixed(0) }}</span> or more
        <div>annual OTC allowance</div>
      </div>
      <div class="text-4xl font-bold font-dm text-center" v-else>
        Do you know about OTC Allowance benefit for approved items with Medicare
        Advantage Plans*
      </div>
      <div class="w-full">
        <img
          v-if="isPaidUser"
          src="../../assets/otc-benefit-card.png"
          width="717"
          height="564"
          class="w-full mx-auto"
        />
        <img
          v-else
          src="../../assets/woman-pharmacy-receipt.png"
          width="1080"
          height="1080"
          class="w-full mx-auto"
        />
      </div>

      <Form
        id="myOtcBenefits"
        scrollBehavior="keepPos"
        :steps="[{ id: 'start' }, { id: 'call' }]"
        product="medicare"
      />
    </div>

    <!-- <Modal :open="showBackButtonModal" @close="showBackButtonModal = false">
      <ModalBackButton @close="showBackButtonModal = false" />
    </Modal> -->
  </Layout>
</template>

<route lang="json">
{
  "meta": {
    "brands": ["bh", "med10", "sd", "boomer", "bridge"],
    "robots": "noindex",
    "benefits": ["otc"],
    "smid": {
      "bh": "MULTI-PLAN_HLWEB0624182_M"
    }
  }
}
</route>
